declare var jQuery:any;
declare var $:any;

import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SessionStorageService } from 'ngx-webstorage';
import { DUtilidadesFormularioServicio } from '@dian-cmp/formulario';
import { TranslateService } from '@ngx-translate/core';
import { environment } from './../../../environments/environment'; 
import { DFormularioConfiguracion  } from './../../configuracion/dformulario-configuracion'; 

@Component({
  moduleId: module.id,
  selector: 'app-pie',
  templateUrl: 'pie.component.html',
  styleUrls:  ['pie.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    DUtilidadesFormularioServicio
  ]
})
export class PieComponent implements OnInit {

  public param: any = {anio: new Date().getFullYear()};
  public mostrarBotonAyudaCasillas: boolean = true;
  public habilitarAyudaCasillas: boolean = true;
  public idioma: string = 'es';
  public soportaMultiIdioma: boolean = false;
  public release = environment.release; 
  public formConf: DFormularioConfiguracion;
  /**
  * @constructor
  */
  constructor(
    private _sessionStorage: SessionStorageService,
    private _utilidades: DUtilidadesFormularioServicio,
    private activatedRoute:ActivatedRoute,  
    private translate: TranslateService
  ){
    //idioma por defecto  
    //translate.setDefaultLang('es');
    this._sessionStorage.store('AYUDA_CASILLAS', this.habilitarAyudaCasillas);
    this.mostrarBotonAyudaCasillas = this._utilidades.esDispositivoMovil();
    this.formConf = new DFormularioConfiguracion();
  }

  /**
  * @desc Función para llamar todos los metodos que carguen los elementos del formulario
  * como tambien los datos del formulario
  */
  ngOnInit() {
    console.info('Formato: ' + this.formConf.NUMERO_FORMULARIO + ' - Versión: ' + this.formConf.VERSION_FORMATO + ' - Lanzamiento:', environment.release);
    this.activatedRoute
      .queryParams
      .subscribe((params: Params) => {
          if (params.hasOwnProperty('lang') && params.lang) {
            this.translate.setDefaultLang(params.lang);
            this.idioma = params.lang;
          } else {
            //idioma por defecto  
            this.translate.setDefaultLang('es');
          }
      });
  } 

  /**
  * @desc Funcion para cambiar el idioma
  * @param {String} idioma
  */
  public cambiarIdioma(idioma: string) {
      this.idioma = idioma;
      this.translate.use(idioma);
  }

  /**
  * @desc Funcion para guardar en el storage si el cliente desea o no habilitar la ayuda de las casillas
  */
  public habilitarDesahabilitarAyudaCasillas() {
    this.habilitarAyudaCasillas = !this.habilitarAyudaCasillas;
    this._sessionStorage.store('AYUDA_CASILLAS', this.habilitarAyudaCasillas);
  }

  /**
  * @desc Funcion para cerrar la ayuda material desde el boton de ayuda
  */
  private cerrarAyudaBtn() {
    $('.ayuda').tapTarget('close'); 
    $(".ayuda").remove();
    $("#btn-ayuda").show(); 
  }
      
}



// WEBPACK FOOTER //
// D:/350/v5/ng_retefuente350v5/Front_formReteFuente350v5/src/app/components/pie/pie.component.ts